import api from '../ApiService';
export type CollectorPreferences = {
  interests: Array<'collect' | 'build' | 'events'>;
  home_focus: 'auto' | 'collect' | 'build' | 'both';
  introduction_dismissed: boolean;
  photo_writes_enabled?: boolean;
  photo_retired?: boolean;
};
export type SpotFields = {
  title: string;
  make: string;
  model: string;
  generation: string;
  event_context: string;
  capture_source?: 'camera' | 'library';
  note: string;
  occurred_at: string;
};
export type Spot = SpotFields & {
  id: string;
  linked_vehicle_id: number | null;
  entry_key: string;
  capture_source: 'camera' | 'library';
};
export type CollectionEntry = {
  key: string;
  title: string;
  make: string;
  model: string;
  image_spot_id: string | null;
  evidence: string;
  occurred_at?: string;
  spots: Spot[];
  encounters: Array<{ public_id: string; evidence: string; occurred_at: string }>;
  memories: Array<{ id: number; note: string; occurred_at: string }>;
  vehicle: { title: string; path: string } | null;
};
export type PersonalSet = {
  slug: string;
  title: string;
  description: string;
  version: number;
  evidence: string;
  slots: Array<{ label: string; done: boolean }>;
};
export type CollectorSummary = {
  entries: number;
  occasions: number;
  linked_cars: number;
  identified_models: number;
  pending: number;
  memories: number;
};
export async function collectorRequest<T>(
  action: string,
  options: RequestInit = {},
  query: Record<string, string> = {}
): Promise<T> {
  const res = await api.makeRequest<T>(
    `/collector.php?${new URLSearchParams({ action, ...query })}`,
    options
  );
  if (!res.success || res.data === undefined)
    throw new Error(res.error || 'Could not load your Passport');
  return res.data;
}
export function collectorWrite<T>(
  action: string,
  body: unknown,
  method = 'POST',
  id?: string
): Promise<T> {
  return collectorRequest<T>(action, { method, body: JSON.stringify(body) }, id ? { id } : {});
}
export async function collectorPhoto(id: string): Promise<Blob> {
  const generation = api.sessionGeneration;
  const response = await fetch(
    `${api.baseUrl}/collector.php?action=media&id=${encodeURIComponent(id)}`,
    { headers: api.getAuthHeaders(), credentials: 'include', cache: 'no-store' }
  );
  if (!response.ok) throw new Error('Photo unavailable');
  const blob = await response.blob();
  if (generation !== api.sessionGeneration) throw new Error('Session changed');
  return blob;
}
